import React from "react";
import { usePutSegmentFindFilterQuery } from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import useSearchable from "@tiny/components/src/hooks/useSearchable";
import { AudiencesListDialogProps } from "./AudiencesListDialog";

export const pageableDefault = {
  page: 0,
  size: 5,
  sort: ["updatedAt,DESC"],
};

export function useAudiencesListDialog(props: AudiencesListDialogProps) {
  const { pageName = "" } = props;
  const {
    pageable,
    search,
    searchDebounced,
    handleSearchChange,
    handlePageChange,
    handleSizeChange,
  } = useSearchable(pageableDefault, pageName);

  const {
    data: { content = [], last, totalElements = 0 } = {},
    refetch,
    isLoading,
  } = usePutSegmentFindFilterQuery(
    {
      searchTextName: searchDebounced,
      segmentTypes: ["UPLOAD"],
    },
    pageable,
    {
      keepPreviousData: true,
    }
  );

  useRefreshRegister(async () => {
    await refetch();
  });

  const reloadAudiences = React.useCallback(() => {
    refetch();
  }, [refetch]);

  const itemsPerPageOptions = [5, 10, 15, 20];
  const totalCount = totalElements;
  const hasMore = !last;
  const page = pageable.page;
  const itemsPerPage = pageable.size;

  return {
    content,
    handlePageChange,
    handleSearchChange,
    handleSizeChange,
    hasMore,
    isLoading,
    itemsPerPage,
    itemsPerPageOptions,
    page,
    reloadAudiences,
    search,
    totalCount,
  };
}
